module.exports = __webpack_public_path__ + "img/img_17.83434651.svg";